export default import.meta.ROLLDOWN_FILE_URL_ED5RWZiRiUmftnX9N4C5mw